export { FastshiftTablePagination } from "./fastshift-table-pagination";
